import { Component, Input } from '@angular/core'

@Component({
  selector: 'app-ib-unclassified',
  templateUrl: './ib-unclassified.component.html',
  standalone: false,
})
export class IbUnclassifiedComponent {
  @Input() images: string[] = []
}
